@if (viewers().length > 0) {
  <div
    data-testid="presence-avatars"
    class="flex items-center -space-x-[2px]"
    role="group"
    [attr.aria-label]="viewers().length + ' people viewing'">
    @for (viewer of visibleViewers(); track viewer.userId) {
      <span
        [title]="viewerLabel(viewer)"
        [attr.aria-label]="viewerLabel(viewer)">
        <app-account-icon
          [initials]="viewerInitials(viewer)"
          [colors]="viewerColor(viewer)"
          [isNightMode]="isNightMode()"
          size="sm" />
      </span>
    }
    @if (hiddenViewers().length > 0) {
      <span
        data-testid="presence-avatars-overflow"
        [title]="hiddenViewersLabel()"
        [attr.aria-label]="hiddenViewersLabel()">
        <app-account-icon
          [initials]="overflowInitials()"
          [colors]="overflowColor"
          [isNightMode]="isNightMode()"
          size="sm" />
      </span>
    }
  </div>
}
